module.exports = __webpack_public_path__ + "media/images/flags/16/South-Sudan-89bad7cf6f67ddecd146d7460899fb27.png";